import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Home from './Home';
import FlightSearchComponent from './Home2';
import MyComponent from './Hotels';
import Restaurant from './Restaurant';
import TripPlannerComponent from './Trip';
import WeatherComponent from './weather';
import TravelBlogs from './blogs';
import Living from './living';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
